/* eslint-disable react/prop-types */
import React from "react";
import { Box } from "@mui/material";
import { Colors } from "../../assets/colors";

function Card({
  children,
  paddingTop = 0,
  paddingBottom = 0,
  paddingLeft = 0,
  paddingRight = 0,
  width = "auto",
  justifyContent = "space-between",
  style,
}) {
  const styles = {
    boxStyle: {
      maxWidth: "100%",
      backgroundColor: Colors.cardBgColor,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingTop: paddingTop,
      paddingBottom: paddingBottom,
      display: "flex",
      borderWidth: {
        xs: 5,
        sm: 3,
        md: 5,
      },
      borderColor: Colors.white,
      borderStyle: "solid",
      borderRadius: {
        xs: 5,
        sm: 3,
        md: 5,
      },
      alignItems: "center",
      justifyContent: justifyContent,
      width: width,
      flexWrap: "wrap",
    },
  };

  return <Box sx={{ ...style, ...styles.boxStyle }}>{children}</Box>;
}

export default Card;
